module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_18.3309bcba.pdf";